import axios from './axios';

export default {
  list() {
    return axios.get('/homepages');
  },
  cgv() {
    return axios.get('/homepages/cgv');
  },
  cgu() {
    return axios.get('/homepages/cgu');
  },
};
